export default __webpack_public_path__ + "static/media/buu.8d9c102d.jpg";